var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',[_c('v-flex',[_vm._v(" Post comming soon... ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }